import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUserType } from "../redux/features/auth/authSlice";
import { toast } from "react-toastify";

export const useRedirectEmployee = () => {
    const navigate = useNavigate();
    const userType = useSelector(selectUserType);

    useEffect(() => {
        if (userType === "employee") {
            toast.info("You are not authorized to access this page");
            navigate("/category");
        }
    }, [userType, navigate]);
};
